import React, { useState, useEffect } from "react";
import PopUpScreen from "../../component/popUpScreen/popUpScreen";
import Select from "react-select";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { LabelWrapper } from "../../component/inputtext/inputtextStyle";
import { FieldLabel } from "../global/global.style";
import { Message } from "primereact/message";
import { useQuery } from "@tanstack/react-query";
import accessManagementService from "../../services/accessManagementService";
import { UpdateUserMutation } from "../../mutations/AccessManagementMutationHook";
import { useToast } from "../../context/ToastContext";
import { GetDomainAndSubdomains } from "../../queries/appQueries";
import { Pencil } from "lucide-react";

function EditMemberDialog({ onHide, userData }) {

  console.log("user data", userData)
  // Data fetching
  const { data: parentDomainData = {}, isLoading: isParentDomainLoading } = GetDomainAndSubdomains();
  const { data: countryAndRegion = {}, isLoading: isCountryAndRegionsLoading } = useQuery({
    queryKey: ["getCountryAndRegions"],
    queryFn: () => accessManagementService.getCountryAndRegion(),
  });
  const { data: allRoles = [], isLoading: isAllRolesDataLoading } = useQuery({
    queryKey: ["getAllUserRoles"],
    queryFn: () => accessManagementService.getAllRoles(),
  });
  const rolesToDisplay = Array.isArray(allRoles) ? allRoles : [];
  const { data: productsData = [], isLoading: isProductsLoading } = useQuery({
    queryKey: ["getProducts"],
    queryFn: () => accessManagementService.getProducts(),
  });
  const toast = useToast();
  const { mutate: updateUser, isPending: isUserUpdating } = UpdateUserMutation(
    () => {
      toast({ severity: "info", summary: "Confirmed", detail: `User Updated Successfully`, life: 3000 });
      onHide();
    },
    (error) => {
      toast({ severity: "info", summary: "Error", detail: error?.response?.data?.detail || error.message, life: 3000 });
    }
  );

  console.log(
    "isUserUpdating", isUserUpdating
  )

  // State for all fields (move to top before any usage)
  const [email, setEmail] = useState(userData?.user_email || "");
  const [parentDomain, setParentDomain] = useState([]);
  const [domain, setDomain] = useState([]);
  const [subDomain, setSubDomain] = useState([]);
  const [products, setProducts] = useState([]);
  const [cluster, setCluster] = useState(null);
  const [market, setMarket] = useState(null);
  const [role, setRole] = useState(null);
  const [errors, setErrors] = useState({});
  const [isEditingDomain, setIsEditingDomain] = useState(false);

  // Add new state for all subdomains
  const [allSubdomains, setAllSubdomains] = useState([]);
  const [prepopulatedSubdomainIds, setPrepopulatedSubdomainIds] = useState([]);
  
  const [allProducts, setAllProducts] = useState([]);
  const [prepopulatedProductNames, setPrepopulatedProductNames] = useState([]);

  const domainArray = userData.domains.map(item => item.domain);
  const parentDomainArray = userData.domains.map(item => item.parent_domain);
  const subdomainArray = userData.domains.flatMap(item => item.subdomains);
  const productinArray = userData.product_names;

  const domainStringValue = domainArray.join(", ");
  const parentDomainStringValue = parentDomainArray.join(", ");
  const subdomainStringValue = subdomainArray.join(", ");
  const productStringValue = productinArray.join(", ");

  // Extract all subdomains when parentDomainData loads
  useEffect(() => {
    if (parentDomainData?.parent_domains) {
      const extractedSubdomains = parentDomainData.parent_domains.flatMap(parentDomain =>
        parentDomain.domains.flatMap(domain =>
          domain.sub_domains.map(subdomain => ({
            value: subdomain.sub_domain_id,
            label: subdomain.sub_domain
          }))
        )
      );
      setAllSubdomains(extractedSubdomains);
    }
  }, [parentDomainData]);

  // Populate subdomain IDs when allSubdomains and userData are available
  useEffect(() => {
    if (allSubdomains.length > 0 && userData.domains) {
      const matchingIds = subdomainArray
        .map(subdomainName => {
          const match = allSubdomains.find(sd => sd.label === subdomainName);
          return match ? match.value : null;
        })
        .filter(id => id !== null);
      
      setPrepopulatedSubdomainIds(matchingIds);
    }
  }, [allSubdomains, userData.domains]);

  // Single console.log for debugging - remove in production
  useEffect(() => {
    console.log( "all data", {
      allSubdomains,
      subdomainArray,
      prepopulatedSubdomainIds
    });
  }, [allSubdomains, subdomainArray, prepopulatedSubdomainIds]);

  console.log("parent domain ", parentDomain.map(pd => pd.label).join(', '))
  console.log("parent domain1 ", parentDomain)

  
  // Helper: get all products from selected sub domains
  const getAvailableProducts = (selectedSubDomains) => {
    if (!selectedSubDomains || selectedSubDomains.length === 0) return [];
    const allProducts =  productsData.filter(pd => selectedSubDomains.some(sd => sd.sub_domain_id === pd.sub_domain_id));
    return allProducts;
  };

  // Helper: get all domains from selected parent domains
  const getAvailableDomains = (selectedParentDomains) => {
    if (!selectedParentDomains || selectedParentDomains.length === 0) return [];
    const allDomains = [];
    selectedParentDomains.forEach(parentDomain => {
      if (parentDomain.domains) {
        allDomains.push(...parentDomain.domains);
      }
    });
    return allDomains;
  };
  // Helper: get all subdomains from selected domains
  const getAvailableSubdomains = (selectedDomains) => {
    if (!selectedDomains || selectedDomains.length === 0) return [];
    const allSubdomains = [];
    selectedDomains.forEach(domain => {
      if (domain.sub_domains) {
        allSubdomains.push(...domain.sub_domains);
      }
    });
    return allSubdomains;
  };

  // React-select expects options as {label, value, ...}
  const parentDomainOptions = Array.isArray(parentDomainData?.parent_domains)
    ? parentDomainData.parent_domains.map(pd => ({ ...pd, label: pd.parent_domain, value: pd.parent_domain_id }))
    : [];
  const domainOptions = getAvailableDomains(parentDomain).map(d => ({ ...d, label: d.domain, value: d.domain_id }));
  const subDomainOptions = getAvailableSubdomains(domain).map(sd => ({ ...sd, label: sd.sub_domain, value: sd.sub_domain_id }));
  const roleOptions = rolesToDisplay.map(role => ({ label: role.role_name, value: role.role_id, ...role }));
  const clusterOptions = Array.isArray(countryAndRegion)
    ? countryAndRegion.filter((obj, index, self) =>
        index === self.findIndex((item) => item.region === obj.region)
      ).map(item => ({ label: item.region, value: item.region }))
    : [];

  const getAvailableMarkets = (selectedRegion) => {
    if (!selectedRegion) return [];
    const allMarkets = countryAndRegion.find(car => car.region === selectedRegion.value).countries;
    return allMarkets;
  };

  const marketOptions = getAvailableMarkets(cluster).map(country => ({ label: country, value: country }));
  const productOptions = getAvailableProducts(subDomain).map(p => ({ ...p, label: p.product_name, value: p.product_name}));

  // Pre-populate values from userData
  // Find parent domains, domains, subdomains, cluster, market, role from userData
  const getPrePopulatedParentDomains = () => {
    if (!userData?.domains || !parentDomainOptions) return [];
    return parentDomainOptions.filter(pd =>
      userData.domains.some(d => d.parent_domain === pd.label)
    );
  };
  const getPrePopulatedDomains = () => {
    if (!userData?.domains || !parentDomain) return [];
    const availableDomains = getAvailableDomains(parentDomain);
    return availableDomains.filter(domain =>
      userData.domains.some(d => d.domain === domain.domain)
    ).map(d => ({ ...d, label: d.domain, value: d.domain_id }));
  };
  const getPrePopulatedSubDomains = () => {
    if (!userData?.domains || !domain) return [];
    const availableSubdomains = getAvailableSubdomains(domain);
    return availableSubdomains.filter(sd =>
      userData.domains.some(d => d.subdomains.includes(sd.sub_domain))
    ).map(sd => ({ ...sd, label: sd.sub_domain, value: sd.sub_domain_id }));
  };
  const getPrePopulatedProducts = () => {
    if (!userData?.products) return [];
    const availableProducts = getAvailableProducts(subDomain);
    return availableProducts.filter(p => userData.products.some(d => d.products.includes(p.product_name)))
    .map(p => ({ ...p, label: p.product_name, value: p.product_name}));
  }
  const getPrePopulatedCluster = () => {
    if (!userData?.region) return null;
    return clusterOptions.find(opt => opt.value === userData.region) || null;
  };
  const getPrePopulatedMarket = () => {
    if (!userData?.country) return null;
    return marketOptions.find(opt => opt.value === userData.country) || null;
  };
  const getPrePopulatedRole = () => {
    if (!userData?.role_id) return null;
    return roleOptions.find(opt => opt.value === userData.role_id) || null;
  };

  // Pre-populate on data load (fix dependencies and ensure .label is set)
  useEffect(() => {
    setParentDomain(getPrePopulatedParentDomains());
  }, [JSON.stringify(parentDomainOptions), userData]);
  useEffect(() => {
    setDomain(getPrePopulatedDomains());
  }, [JSON.stringify(parentDomain), JSON.stringify(parentDomainOptions), userData]);
  useEffect(() => {
    setSubDomain(getPrePopulatedSubDomains());
  }, [JSON.stringify(domain), JSON.stringify(parentDomain), JSON.stringify(parentDomainOptions), userData]);
  useEffect(() => {
    setCluster(getPrePopulatedCluster());
  }, [JSON.stringify(clusterOptions), userData]);
  useEffect(() => {
    setMarket(getPrePopulatedMarket());
  }, [JSON.stringify(cluster), JSON.stringify(marketOptions), userData]);
  useEffect(() => {
    setRole(getPrePopulatedRole());
  }, [JSON.stringify(roleOptions), userData]);
  useEffect(() => {
    setProducts(getPrePopulatedProducts());
  }, [JSON.stringify(subDomain), JSON.stringify(subDomainOptions), userData])

  // Reset domain/subdomain if parentDomain/domain changes
  useEffect(() => { setDomain([]); setSubDomain([]); }, [parentDomain]);
  useEffect(() => { setSubDomain([]); }, [domain]);

  // Reusable Select styles
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: 45,
      border: '1px solid #ced4da',
      borderRadius: 8,
      boxShadow: state.isFocused ? '0 0 0 2px rgba(0, 0, 160, 0.1)' : 'none',
      borderColor: state.isFocused ? '#0000a0' : '#ced4da',
      '&:hover': {
        borderColor: '#0000a0'
      },
      width: '100%'
    }),
    menu: base => ({ 
      ...base, 
      zIndex: 9999,
      width: '100%'
    }),
    menuList: base => ({
      ...base,
      maxHeight: 200
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#0000a0' : state.isFocused ? '#f0f8ff' : 'white',
      color: state.isSelected ? 'white' : '#333',
      '&:hover': {
        backgroundColor: state.isSelected ? '#000080' : '#f0f8ff'
      }
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: '#f0f8ff',
      border: '1px solid #0000a0',
      borderRadius: 4
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: '#0000a0',
      fontWeight: 500,
      fontSize: '13px'
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: '#0000a0',
      '&:hover': {
        backgroundColor: '#0000a0',
        color: 'white'
      }
    }),
    valueContainer: (base) => ({
      ...base,
      padding: '8px 12px',
      width: '100%'
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0
    }),
    placeholder: (base) => ({
      ...base,
      color: '#999',
      fontSize: '14px'
    }),
    singleValue: (base) => ({
      ...base,
      color: '#333',
      fontSize: '14px'
    })
  };

  // Validation
  const validate = () => {
    if (isEditingDomain) {
      const newErrors = {};
  
      if (!email) newErrors.email = "Email is required";
      else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) newErrors.email = "Invalid email address";
  
      if (parentDomain.length === 0) newErrors.parentDomain = "Domain is required";
      if (domain.length === 0) newErrors.domain = "Sub Domain is required";
      if (subDomain.length === 0) newErrors.subDomain = "Sub Sub Domain is required";
      if (!cluster) newErrors.cluster = "Region is required";
      if (!market) newErrors.market = "Market is required";
      if (!role) newErrors.role = "Access is required";
  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    } else {
      const newErrors = {};
  
      if (!email) newErrors.email = "Email is required";
      else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) newErrors.email = "Invalid email address";
  
      if (!cluster) newErrors.cluster = "Region is required";
      if (!market) newErrors.market = "Market is required";
      if (!role) newErrors.role = "Access is required";
  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    }
  };

  // Handle submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    // Use either the edited subdomains or the prepopulated ones
    const subDomainIds = isEditingDomain 
      ? subDomain.map(sub => sub.sub_domain_id)
      : prepopulatedSubdomainIds;

    const productNames = isEditingDomain ? products.map(p => p.product_name) : prepopulatedProductNames;

    updateUser({
      user_id: userData.user_id,
      role_id: role.value,
      country: market.label,
      region: cluster.label,
      cluster: cluster.label,
      last_modified_by: localStorage.getItem("userId"),
      subdomain_ids: isEditingDomain ? subDomainIds : prepopulatedSubdomainIds,
      product_names: isEditingDomain ? productNames : prepopulatedProductNames
    });
  };

  return (
    <>
      <style>
        {`
          .input-container:focus-within {
            border-color: #0000a0 !important;
            box-shadow: 0 0 0 1px #0000a0 !important;
          }
        `}
      </style>
      <PopUpScreen header="Edit Member" onHide={onHide} style={{ width: "40%" }}>
      <form onSubmit={handleSubmit}>
        <div className="grid">
          {/* Email */}
          <div className="col-12" style={{paddingTop : '20px'}}>
            <LabelWrapper>
              <FieldLabel>Email</FieldLabel>
            </LabelWrapper>
            <div 
              className="input-container"
              style={{ 
                minHeight: 45, 
                border: '1px solid #ced4da', 
                borderRadius: 8, 
                display: 'flex', 
                alignItems: 'center', 
                paddingLeft: 12, 
                background: '#fff',
                transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
              }}
            >
              <InputText
                placeholder="Enter your Email"
                id="email"
                name="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                style={{ 
                  width: "100%", 
                  border: 'none', 
                  boxShadow: 'none', 
                  outline: 'none', 
                  background: 'transparent', 
                  height: 40, 
                  paddingLeft: 0,
                  fontSize: '14px',
                  color: '#333'
                }}
              />
            </div>
            {errors.email && <Message className="my-2 w-full" severity="warn" text={errors.email} />}
          </div>

          {/* Domain, Sub Domain, Sub Sub Domain - Readonly with Edit button, vertically stacked */}
          {!isEditingDomain ? (
            <>
              <div className="col-12" style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                  <LabelWrapper>
                    <FieldLabel>Parent Domain</FieldLabel>
                  </LabelWrapper>
                  <InputText
                    value= {parentDomainStringValue}
                    readOnly
                    style={{ 
                      width: '100%', 
                      background: '#f8f9fa', 
                      border: '1px solid #e9ecef', 
                      borderRadius: 8, 
                      height: 45, 
                      paddingLeft: 12,
                      fontSize: '14px',
                      color: '#495057',
                      fontWeight: 500
                    }}
                    placeholder="Domain"
                  />
                </div>
                <button
                  type="button"
                  onClick={() => setIsEditingDomain(true)}
                  style={{ 
                    background: 'none', 
                    border: 'none', 
                    cursor: 'pointer', 
                    marginLeft: 12, 
                    marginTop: 24,
                    padding: '8px',
                    borderRadius: '6px',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: '#f0f8ff'
                    }
                  }}
                  title="Edit Domain"
                >
                  <Pencil size={20} color="#0000a0" />
                </button>
              </div>
              <div className="col-12" style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                  <LabelWrapper>
                    <FieldLabel>Sub Domain</FieldLabel>
                  </LabelWrapper>
                  <InputText
                    value={subdomainStringValue}
                    readOnly
                    style={{ 
                      width: '100%', 
                      background: '#f8f9fa', 
                      border: '1px solid #e9ecef', 
                      borderRadius: 8, 
                      height: 45, 
                      paddingLeft: 12,
                      fontSize: '14px',
                      color: '#495057',
                      fontWeight: 500
                    }}
                    placeholder="Sub Domain"
                  />
                </div>
                <button
                  type="button"
                  onClick={() => setIsEditingDomain(true)}
                  style={{ 
                    background: 'none', 
                    border: 'none', 
                    cursor: 'pointer', 
                    marginLeft: 12, 
                    marginTop: 24,
                    padding: '8px',
                    borderRadius: '6px',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: '#f0f8ff'
                    }
                  }}
                  title="Edit Sub Domain"
                >
                  <Pencil size={20} color="#0000a0" />
                </button>
              </div>
              <div className="col-12" style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                  <LabelWrapper>
                    <FieldLabel>Product</FieldLabel>
                  </LabelWrapper>
                  <InputText
                    value={productStringValue}
                    readOnly
                    style={{ 
                      width: '100%', 
                      background: '#f8f9fa', 
                      border: '1px solid #e9ecef', 
                      borderRadius: 8, 
                      height: 45, 
                      paddingLeft: 12,
                      fontSize: '14px',
                      color: '#495057',
                      fontWeight: 500
                    }}
                    placeholder="Sub Sub Domain"
                  />
                </div>
                <button
                  type="button"
                  onClick={() => setIsEditingDomain(true)}
                  style={{ 
                    background: 'none', 
                    border: 'none', 
                    cursor: 'pointer', 
                    marginLeft: 12, 
                    marginTop: 24,
                    padding: '8px',
                    borderRadius: '6px',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: '#f0f8ff'
                    }
                  }}
                  title="Edit Sub Sub Domain"
                >
                  <Pencil size={20} color="#0000a0" />
                </button>
              </div>
            </>
          ) : (
            <>
              {/* (Parent Domain) */}
              <div className="col-12">
                <LabelWrapper>
                  <FieldLabel>Parent Domain</FieldLabel>
                </LabelWrapper>
                <Select
                  isMulti
                  isLoading={isParentDomainLoading}
                  isDisabled={isParentDomainLoading}
                  options={parentDomainOptions}
                  value={parentDomain}
                  onChange={setParentDomain}
                  placeholder={isParentDomainLoading ? "Loading..." : "Choose Domain"}
                  styles={selectStyles}
                />
                {errors.parentDomain && <Message className="my-2 w-full" severity="warn" text={errors.parentDomain} />}
              </div>

              {/* (Domain) */}
              <div className="col-12">
                <LabelWrapper>
                  <FieldLabel>Domain</FieldLabel>
                </LabelWrapper>
                <Select
                  isMulti
                  isLoading={isParentDomainLoading}
                  isDisabled={isParentDomainLoading || parentDomain.length === 0}
                  options={domainOptions}
                  value={domain}
                  onChange={setDomain}
                  placeholder={isParentDomainLoading ? "Waiting for Domain..." : (parentDomain.length === 0 ? "Select Domain(s) first" : "Choose Sub Domain")}
                  styles={selectStyles}
                />
                {errors.domain && <Message className="my-2 w-full" severity="warn" text={errors.domain} />}
              </div>

              {/* (Sub Domain) */}
              <div className="col-12">
                <LabelWrapper>
                  <FieldLabel>Sub Domain</FieldLabel>
                </LabelWrapper>
                <Select
                  isMulti
                  isLoading={isParentDomainLoading}
                  isDisabled={isParentDomainLoading || domain.length === 0}
                  options={subDomainOptions}
                  value={subDomain}
                  onChange={setSubDomain}
                  placeholder={isParentDomainLoading || domain.length === 0 ? "Select Sub Domain(s) first" : "Choose Sub Sub Domain"}
                  styles={selectStyles}
                />
                {errors.subDomain && <Message className="my-2 w-full" severity="warn" text={errors.subDomain} />}
              </div>

              {/* Product */}
              <div className="col-12">
                <LabelWrapper>
                  <FieldLabel>Product</FieldLabel>
                </LabelWrapper>
                <Select
                  isMulti
                  isLoading={isProductsLoading}
                  isDisabled={isProductsLoading || subDomain.length === 0}
                  options={productOptions}
                  value={products}
                  onChange={setProducts}
                  placeholder={isProductsLoading || subDomain.length === 0? "Select Sub Domain(s) first" :  "Select Products"}
                  styles={selectStyles}
                />
                {errors.product && <Message className="my-2 w-full" severity="warn" text={errors.product} />}
              </div>
            </>
          )}

          {/* Region (Cluster) */}
          <div className="col-12">
            <LabelWrapper>
              <FieldLabel>Region</FieldLabel>
            </LabelWrapper>
            <Select
              isLoading={isCountryAndRegionsLoading}
              isDisabled={isCountryAndRegionsLoading}
              options={clusterOptions}
              value={cluster}
              onChange={setCluster}
              placeholder={isCountryAndRegionsLoading ? "Loading..." : "Select Region"}
              styles={selectStyles}
            />
            {errors.cluster && <Message className="my-2 w-full" severity="warn" text={errors.cluster} />}
          </div>

          {/* Market */}
          <div className="col-12">
            <LabelWrapper>
              <FieldLabel>Market</FieldLabel>
            </LabelWrapper>
            <Select
              isLoading={isCountryAndRegionsLoading}
              isDisabled={isCountryAndRegionsLoading || !cluster}
              options={marketOptions}
              value={market}
              onChange={setMarket}
              placeholder={isCountryAndRegionsLoading ? "Loading..." : (!cluster ? "Select Region first" : "Select Market")}
              styles={selectStyles}
            />
            {errors.market && <Message className="my-2 w-full" severity="warn" text={errors.market} />}
          </div>

          {/* Access (Role) */}
          <div className="col-12">
            <LabelWrapper>
              <FieldLabel>Access</FieldLabel>
            </LabelWrapper>
            <Select
              isLoading={isAllRolesDataLoading}
              isDisabled={isAllRolesDataLoading}
              options={roleOptions}
              value={role}
              onChange={setRole}
              placeholder={isAllRolesDataLoading ? "Loading..." : "Choose the Access"}
              styles={selectStyles}
            />
            {errors.role && <Message className="my-2 w-full" severity="warn" text={errors.role} />}
          </div>
        </div>
        <div className="grid">
          <div className="col-12 mt-4">
            <Button
              label="Submit"
              type="submit"
              className="p-button-primary bg-[#0000a0] px-4 py-2 text-white"
              disabled={isUserUpdating}
              loading={isUserUpdating}
              style={{ float: "right" }}
            />
            <Button
              label="Cancel"
              className="px-4 py-2 border border-[#0000a0] text-[#0000a0] hover:bg-blue-50 transition"
              onClick={onHide}
              style={{ float: "right", marginRight: "10px" }}
            />
          </div>
        </div>
      </form>
    </PopUpScreen>
    </>
  );
}

export default EditMemberDialog; 